import {
  BizNestClientError,
  EhttpController,
  FrontendLogger,
  IehttpControllerConfig
} from '@biz-nest/core-client';

/**
 * A client for handling email operations within the application.
 * This class provides a wrapper around the HTTP client for making email-related requests.
 *
 * @class FlyingMailClient
 * @example
 * const config = { baseURL: 'https://api.example.com' };
 * const mailClient = new FlyingMailClient(config);
 */
export class FlyingMailClient {
  /** @private @static @type {EhttpController} */
  private static http: EhttpController;

  /**
   * Creates a new instance of FlyingMailClient.
   *
   * @param {IehttpControllerConfig} config - Configuration object for the HTTP client.
   * @throws {BizNestClientError} If the provided configuration is invalid or missing.
   *
   * @example
   * const mailClient = new FlyingMailClient({
   *   baseURL: 'https://api.example.com/email'
   * });
   */
  constructor(config: IehttpControllerConfig) {
    if (!config || typeof config !== 'object') {
      throw new BizNestClientError('config must be a valid configuration object');
    }

    FrontendLogger.debug('FlyingMailClient initialized');
    FlyingMailClient.http = new EhttpController(config);
  }

  /**
   * Gets the underlying HTTP client instance.
   *
   * @static
   * @returns {EhttpController} The initialized HTTP client instance.
   * @throws {BizNestClientError} If the HTTP client has not been initialized.
   *
   * @example
   * const http = FlyingMailClient.ehttp;
   */
  static get ehttp() {
    if (!FlyingMailClient.http) {
      throw new BizNestClientError('HTTP client not initialized. Call new FlyingMailClient() first.');
    }

    return FlyingMailClient.http;
  }
}
